import { useDrawFile } from "../hook/use_draw_file";
import "./RemoveLine.css";
import { updateFileDetail } from "../context/fileDetailsReducer";
import { useDispatch } from 'react-redux';

const RemoveLine = ({ index, isOpen, onOpen, onClose }) => {
    const { removeLine, getRemoveText } = useDrawFile();
    const dispatch = useDispatch();

    const handleRemoveClick = () => {
        dispatch(updateFileDetail({ currentIndex: index }));
        onOpen();
    };

    const handleConfirm = () => {
        removeLine();
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <td className="remove-icon" >
            <img alt="Remove" src="remove.png" onClick={handleRemoveClick} />
            {isOpen && (
                <div className="remove-popup">
                    <div className="remove-popup-content">
                        <div className="remove-popup-text">{getRemoveText()}</div>
                        <div className="remove-popup-actions">
                            <button className="btn btn-primary ok" onClick={handleConfirm}>אישור</button>
                            <button className="btn btn-secondary ok" onClick={handleCancel}>ביטול</button>
                        </div>
                    </div>
                </div>
            )}
        </td>
    );
};

export default RemoveLine;